import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from '../getGroupMember.api';

interface CreateAdjustment {
  adjustment_type: number
  amount: number
  description: string
}

interface UpdateAdjustment {
  id: number
  adjustment_type: number
  amount: number
  description: string
}

export interface UpdateGroupMemberVars {
  id: number
  first_name?: string
  last_name?: string
  group_role?: number
  tour_role?: number
  group_id?: number
  user_id?: number
  email?: string
  cellphone_code?: string
  cellphone?: string
  dob?: string
  validated?: boolean
  cancelled?: boolean
  disabled?: boolean
  authorised?: boolean

  adjustments?: {
    create?: CreateAdjustment[]
    update?: UpdateAdjustment[]
    delete?: number[]
  }
}

export interface UpdateGroupMemberInput {
  data: UpdateGroupMemberVars
}

interface UpdateGroupMemberData {
  __typename?: string,
  updateGroupMember: GroupMember
}

export const UPDATE_GROUP_MEMBER_MUTATION = gql`
    mutation updateGroupMember($data: UpdateGroupMemberInput!) {
        updateGroupMember(data: $data) {
            ${gqlGroupMember}
        }
    }
`;

export const updateGroupMember = () => useMutation<UpdateGroupMemberData, UpdateGroupMemberInput>(
  UPDATE_GROUP_MEMBER_MUTATION,
  {
    update: updateCacheByType('GroupMember'),
  }
);

export default updateGroupMember;